var _Glyphicon;
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Glyphicon } from 'reaxl';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ListingPaymentCTA(_ref) {
  let {
    className,
    onPaymentCTAClick,
    showIcon,
    ctaText = 'See estimated payment',
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsxs(Button, {
    bsStyle: "text",
    className: className,
    onClick: onPaymentCTAClick,
    ...rest,
    children: [showIcon && (_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
      "aria-hidden": "true",
      glyph: "calculator",
      className: "margin-right-2 padding-bottom-1"
    }))), ctaText]
  });
}
export default ListingPaymentCTA;